import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import DocumentHead from 'legacyComponents/documentHead';
import { SectionBanner, Paragraph, Box } from 'components';
import RFQList from 'apps/rfq/rfqList';
import { MainWrapper } from 'legacyComponents/styled/lib';

import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import { useNoAuthRedirect, useClientStore } from '../../hooks';

const RFQsPage = observer(() => {
  const clientStore = useClientStore();
  const { isMobile } = clientStore;
  useNoAuthRedirect();

  const { activeSpace } = clientStore;
  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s RFQs`
      : 'My RFQs';

  return (
    <div>
      <DocumentHead title={title} />
      <MainWrapper>
        {!isMobile && (
          <SectionBanner
            bannerId='rfq-card'
            imageSrc='/assets/banners/005.svg'
            title='Get quotes and collaborate with match-made Manufacturers.'
            buttonText='Get a Quote'
            linkName='https://wikifactory.com/make-part'
            paddingTop='large'
            paddingBottom='xlarge'
            eventCallback={() => analytics.sendEvent(BANNER_ACTIONS.RFQS)}
          >
            <Box>
              <Paragraph>Ready for a quote?</Paragraph>
              <Paragraph>
                3D printing, CNC machining, sheet metal fabrication, and
                injection molding from <strong>Quality</strong>{' '}
                <strong>Assured manufacturers</strong> from around the world.
              </Paragraph>
              <Paragraph>
                <strong>Engineering support</strong> to advance faster.{' '}
                <strong>Global delivery</strong> to get the parts wherever you
                are.
              </Paragraph>
            </Box>
          </SectionBanner>
        )}
        <RFQList />
      </MainWrapper>
    </div>
  );
});

RFQsPage.propTypes = {
  routerStore: PropTypes.object,
};

export default RFQsPage;
